import dayjs, { Dayjs } from "dayjs";

export const MONTHS_IN_YEAR = 12;
export const FISCAL_YEAR_START_MONTH_INDEX = 8;

const getFiscalYearStartYear = (date: Dayjs) =>
  date.month() >= FISCAL_YEAR_START_MONTH_INDEX ? date.year() : date.year() - 1;

export const getFiscalYearStart = (referenceDate: dayjs.ConfigType): Dayjs => {
  const date = dayjs(referenceDate);
  const fiscalYearStartYear = getFiscalYearStartYear(date);
  return date
    .clone()
    .year(fiscalYearStartYear)
    .month(FISCAL_YEAR_START_MONTH_INDEX)
    .date(1)
    .startOf("day");
};

export const getFiscalYearNumber = (
  referenceDate: dayjs.ConfigType
): number => {
  return getFiscalYearStart(referenceDate)
    .add(MONTHS_IN_YEAR - 1, "month")
    .year();
};

export const getFiscalYearTwoDigit = (
  referenceDate: dayjs.ConfigType
): string => {
  return `${getFiscalYearNumber(referenceDate) % 100}`.padStart(2, "0");
};
